import(/* webpackMode: "eager" */ "/var/www/tripcraftmx/frontend/src/app/[locale]/cart/page.tsx");
